/**
 * Return the first value different from null or undefined.
 * @return {any}
 */
const getFirstDefinedVar = (...vars) => {
  return vars.find((value) => value != null);
};

export default getFirstDefinedVar;
